import { render, staticRenderFns } from "./StructureList.vue?vue&type=template&id=50dcb41a"
import script from "./StructureList.vue?vue&type=script&lang=js"
export * from "./StructureList.vue?vue&type=script&lang=js"
import style0 from "./StructureList.vue?vue&type=style&index=0&id=50dcb41a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports